export default "__VITE_ASSET__7MsKpDLQ__"